/**
 * おはしの「選ぶモード」の決まり（Phaser に依存しない。テストできるように切り出した）。
 *
 * 料理をタップしても、それだけでは1本減らない。タップは「選ぶ」だけで、
 * 「この料理を消す？ はい」を押したとき（confirm）に初めて1本使う。
 * 盤面の左下のおはしボタンを押し間違えて選ぶモードに入り、次のタップで料理に当たると
 * 確認なしで有料のおはしが減っていた（2026-10-05 レビュー5）。1回目だけでなく毎回確かめる。
 */

export class PickSession {
  private activeFlag = false;
  private selectedId: number | null = null;

  /** @param consume おはしを1本使う。使えたら true。 */
  constructor(private readonly consume: () => boolean) {}

  get active(): boolean {
    return this.activeFlag;
  }

  /** いま選んでいる料理（まだ消していない）。 */
  get selected(): number | null {
    return this.selectedId;
  }

  start(): void {
    this.activeFlag = true;
    this.selectedId = null;
  }

  /** 料理をタップした：選ぶだけ。おはしは減らない。別の料理をタップすれば選び直し。 */
  select(pieceId: number): void {
    if (!this.activeFlag) return;
    this.selectedId = pieceId;
  }

  /** 選んだのを取り消す（選ぶモードは続く）。 */
  unselect(): void {
    this.selectedId = null;
  }

  /**
   * 「はい」：選んでいる料理を消してよい。おはしを1本使い、消す料理の id を返す。
   * 選んでいない・使えなかったときは null（選ぶモードは終わる）。
   */
  confirm(): number | null {
    if (!this.activeFlag || this.selectedId === null) return null;
    const id = this.selectedId;
    const ok = this.consume();
    this.stop();
    return ok ? id : null;
  }

  /** 選ぶモードを終える（やめる・一時停止・ゲームオーバー）。 */
  stop(): void {
    this.activeFlag = false;
    this.selectedId = null;
  }
}
